// Determine API URL based on environment
const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const API_URL = isDev
  ? '' // Use relative URLs in dev (Vite proxy handles it)
  : 'https://crowdcam-api.picanteverde.workers.dev';

export const WS_URL = isDev
  ? `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`
  : 'wss://crowdcam-api.picanteverde.workers.dev';
